<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="searchByCik"
    type="text"
    placeholder="Search by cik number"
    class="border-b-1 border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'searchByCik')"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="searchByInsiderName"
    type="text"
    placeholder="Search by insider name"
    class="border-b-1 border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'searchByInsiderName')"
  />
</div>

<div class="mb-4"></div>
<div>
  <p-table
    [value]="insiders"
    [paginator]="insiders.length > 0"
    [rows]="paginator.pageSize"
    (onLazyLoad)="loadData($event)"
    [lazy]="true"
    [totalRecords]="paginator.totalCount"
    [loading]="isLoading"
    [(selection)]="selectedInsiders"
    dataKey="arcId"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onPage)="onInsiderPageChange($event)"
    [rowsPerPageOptions]="[10, 25, 50]"
  >
    <ng-template #header>
      <tr>
        <th>CIK</th>
        <th>InsiderNames</th>
      </tr>
    </ng-template>
    <ng-template #body let-insider>
      <tr>
        <td>{{ insider.cik || "N/A" }}</td>
        <td>{{ insider.insiderNames?.length ? insider.insiderNames.join(' | ') : 'N/A' }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-template #noData>
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-template>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
